import { message } from "antd";
import * as ACTIONS from "app/actions/KUCatalogueActions";

const initialState = {
    isSavingKeyUser: false,
    filter: {
        listNames: [],
    },
    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: 'name',
        order: 'asc',
    },
    isLoadingAllKeyUser: false,
    listAllKeyUser: [],
    isExportingKeyUser: false,
    listAllEmployees: [],
};

export const KUCatalogueReducer = (state = initialState, action) => {
    switch (action.type) {
        //Obtiene la tabla
        case ACTIONS.GET_KEYUSER_LIST_REQUEST:
            return {
                ...state,
                isLoadingAllKeyUser: true,
            };
        case ACTIONS.GET_KEYUSER_LIST_SUCCESS:
            return {
                ...state,
                isLoadingAllKeyUser: false,
                listAllKeyUser: action.payload.data,
            };
        case ACTIONS.GET_KEYUSER_LIST_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingAllKeyUser: false,
            };
        //Obtiene el combo nombres de KeyUsers
        case ACTIONS.POST_KEYUSER_REQUEST:
            return {
                ...state,
                isSavingKeyUser: true,
            };
        case ACTIONS.POST_KEYUSER_SUCCESS:
            return {
                ...state,
                isSavingKeyUser: false,
            };
        case ACTIONS.POST_KEYUSER_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isSavingKeyUser: false,
            };
        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }
        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload,
            };
        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;
        //Export de key user
        case ACTIONS.EXPORT_REQUEST:
            return {
                ...state,
                isExportingKeyUser: true,
            };
        case ACTIONS.EXPORT_SUCCESS:
            return {
                ...state,
                isExportingKeyUser: false,
            };
        case ACTIONS.EXPORT_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isExportingKeyUser: false,
            };
        //Obtiene los empleados disponibles para KU
        case ACTIONS.GET_EMPLOYEE_LIST_REQUEST:
            return {
                ...state,
            };
        case ACTIONS.GET_EMPLOYEE_LIST_SUCCESS:
            return {
                ...state,
                listAllEmployees: action.payload,
            };
        case ACTIONS.GET_EMPLOYEE_LIST_FAILURE:
            return {
                ...state,
                listAllEmployees: [],
            };
        case ACTIONS.DELETE_KEYUSER_CANCELED:
            message.warning(action.payload)
            return {
                ...state,
            }
        case ACTIONS.DELETE_KEYUSER_FAILURE:
            message.error(action.payload)
            return {
                ...state,
            }
        default:
            return state;
    }
};
